import { useState } from 'react'
import { Flex, theme, TooltipInfo, Typography } from '@nilohealth/core-ui'
import { useRouter } from 'next/router'

import { useMetric, UseMetricHook } from '../metrics.hooks'
import { MetricBigNumber } from '../metrics.types'
import { BignumberCard, BigNumberTooltipContainer } from './bignumber.styles'

import BignumberSkeleton from './bignumber.skeleton'
import BignumberBody from './bignumber-body'

type BignumberProps = {
  metricId: string
  url: string | null
  disabled?: boolean
  mode: 'home' | 'category' | 'indicator'
  useQueryHook?: UseMetricHook
}
const Bignumber = ({ metricId, url, mode, disabled = false, useQueryHook = useMetric }: BignumberProps) => {
  const router = useRouter()

  const hasDetails = !!url

  const [isHovered, setHover] = useState(false)

  const { metric, isLoading } = useQueryHook<MetricBigNumber>({ metricId })

  const desktopLineHeight = Number(theme.lineHeights.lineHeight116.value) * 14 // 14px fontSize
  const tabletLineHeight = Number(theme.lineHeights.lineHeight116.value) * 12 // 12px fontSize

  // Make title have 3 times the height of the line
  const desktopTitle = { height: `${3 * desktopLineHeight}px` }
  const tabletTitle = { height: `${3 * tabletLineHeight}px` }

  const openMetric = () => {
    if (url) router.push(`/${url}`)
  }

  const enter = () => setHover(true)

  const leave = () => setHover(false)

  if (isLoading) return <BignumberSkeleton />

  if (!!metric && Object.entries(metric).length > 0) {
    return (
      <BignumberCard
        mode={mode}
        disabled={disabled}
        hasDetails={hasDetails}
        onMouseEnter={enter}
        onMouseLeave={leave}
        onClick={openMetric}
      >
        {!!metric.description && isHovered && (
          <BigNumberTooltipContainer className="bignumber-tooltip-container">
            <TooltipInfo content={metric.description} />
          </BigNumberTooltipContainer>
        )}

        <Flex direction="column" css={{ width: '100%' }}>
          <Typography
            type={{ '@sm': 'subtitleXXSmall', '@md': 'subtitleXSmall', '@lg': 'subtitleXSmall' }}
            weight="regular"
            color="neutralLowDark"
            align="left"
            css={{ '@sm': tabletTitle, '@md': desktopTitle, '@lg': desktopTitle, marginRight: '$micro' }}
          >
            {metric.title}
          </Typography>

         <BignumberBody metric={metric} showDetails={hasDetails && isHovered} />
        </Flex>
      </BignumberCard>
    )
  }
  return null
}

export default Bignumber
